import type {InnStepValues} from './types';

export const FIND_INN_URL = 'https://service.nalog.ru/inn.do';

export const INN_ALREADY_EXISTS_ERROR = 'Исполнитель с таким ИНН уже существует';

const INN_MAX_LENGTH = 12;

export const extractInnDigits = (value: string): string => {
	return value.replace(/\D/g, '').slice(0, INN_MAX_LENGTH);
};

export const formatInnDisplay = (digits: string): string => {
	const normalized = extractInnDigits(digits);

	if (!normalized) {
		return '';
	}

	return normalized.match(/.{1,4}/g)?.join(' ') ?? normalized;
};

export const isInnDigitsValid = (digits: string): boolean => {
	const length = extractInnDigits(digits).length;

	return length === 12;
};

export const buildInnRequest = (values: InnStepValues): {inn: string} | null => {
	const inn = extractInnDigits(values.inn);

	if (!isInnDigitsValid(inn)) {
		return null;
	}

	return {inn};
};
